import { jsx as _jsx } from "react/jsx-runtime";
import { Autocomplete as HeroAutocomplete } from '@heroui/react';
export const Autocomplete = (props) => {
    return _jsx(HeroAutocomplete, { ...props });
};
export { AutocompleteItem } from '@heroui/react';
export { AutocompleteSection } from '@heroui/react';
export default Autocomplete;
//# sourceMappingURL=Autocomplete.js.map